import React from 'react';

import { AuctionTitleContainer } from '../AuctionTitleContainer';
import { BookedOfferLayoutsLinkContainer } from '../BookedOfferLayoutsLinkContainer';
import { GeoContainer } from '../GeoContainer';
import { IdenticalOffersLinkContainer } from '../IdenticalOffersLinkContainer';
import { LabelsListContainer } from '../LabelsListContainer';
import { PriceContainer } from '../PriceContainer';
import { RatingContainer } from '../RatingContainer';
import { ResizableContainer } from '../ResizableContainer';
import { SimilarLinkContainer } from '../SimilarLinkContainer';
import { TitleContainer } from '../TitleContainer';

interface IOfferGeneralInfoContainerProps {
  isNewHighlighting: boolean;
}

export function OfferGeneralInfoContainer({ isNewHighlighting }: IOfferGeneralInfoContainerProps) {
  return (
    <>
      <TitleContainer />
      <LabelsListContainer />
      <GeoContainer />
      <AuctionTitleContainer />
      <PriceContainer isNewHighlighting={isNewHighlighting} />
      <RatingContainer />
      <ResizableContainer />
      <SimilarLinkContainer />
      <IdenticalOffersLinkContainer />
      <BookedOfferLayoutsLinkContainer />
    </>
  );
}
